export function getWritingCorrectionCacheKey(historyId: string) {
  return `tef_writing_correction_${historyId}`;
}

export function saveWritingCorrectionLocally(historyId: string, payload: any) {
  if (!historyId || !payload) return;

  const key = getWritingCorrectionCacheKey(historyId);

  const enrichedPayload = {
    ...payload,
    cachedAt: new Date().toISOString(),
  };

  try {
    localStorage.setItem(key, JSON.stringify(enrichedPayload));
    sessionStorage.setItem(key, JSON.stringify(enrichedPayload));

    console.log("[EE_LOCAL_CORRECTION_SAVED]", {
      key,
      payload: enrichedPayload,
    });
  } catch (error) {
    console.error("[EE_LOCAL_CORRECTION_SAVE_ERROR]", error);
  }
}

export function loadWritingCorrectionLocally(historyId: string) {
  if (!historyId) return null;

  const key = getWritingCorrectionCacheKey(historyId);

  try {
    const fromSession = sessionStorage.getItem(key);
    const fromLocal = localStorage.getItem(key);
    const raw = fromSession || fromLocal;

    if (!raw) {
      console.warn("[EE_LOCAL_CORRECTION_NOT_FOUND]", { key });
      return null;
    }

    const parsed = JSON.parse(raw);

    console.log("[EE_LOCAL_CORRECTION_LOADED]", {
      key,
      parsed,
    });

    return parsed;
  } catch (error) {
    console.error("[EE_LOCAL_CORRECTION_LOAD_ERROR]", error);
    return null;
  }
}
